// extracted by mini-css-extract-plugin
export default {"page":"ki-z","cartModal":"li-z","checkout":"mi-z","placeholder":"ni-z","account":"oi-z"};